document.addEventListener('DOMContentLoaded', () => {

  const cards = document.querySelectorAll('.asia24-step');

  cards.forEach(card => {

    card.addEventListener('mouseenter', () => {
      card.classList.add('active');
    });

    card.addEventListener('mouseleave', () => {
      card.classList.remove('active');
    });

  });

});